import './style/RatingItem.css';

function RatingItem({label, ratingClass, onClick, onHover, onLeave, description}) {
  return (
    <div className='rating-item'>
      <label>{label}</label>
      <div>
        {[0,1,2,3,4,5,6].map(i => (
          <button
            key={i}
            type="button"
            onClick={() => onClick(i)}
            onMouseEnter={() => onHover(i)}
            onMouseLeave={onLeave}
            className={ratingClass[i]}
          />
        ))}
      </div>
      <p>{description}</p>
    </div>
  );
}

export default RatingItem;
